import React from "react";
import { Button } from "@mantine/core";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import styles from "./styles.module.css";

interface SortButtonProps {
  currentDirection: "ASC" | "DESC";
  onClick?: () => void;
}

const SortButton: React.FC<SortButtonProps> = ({ currentDirection, onClick }) => {
  const rotated = currentDirection === "DESC";
  return (
    <Button variant="transparent" className={styles.sortButton} onClick={onClick} aria-label="" aria-pressed={rotated}>
      <SVGAsset name="arrowGrayUpLarge" className={`${styles.arrow} ${rotated ? styles.rotated : ""}`} />
    </Button>
  );
};

export default SortButton;
